const initialState = {
  adminShareFavouriteFilterStatus: null,
  isLoadingAdminShareFavouriteFilterStatus: false,
};

export const AdminShareFavouriteReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'POST_ADMIN_SHARE_FAVOURITE_FILTER':
      return {
        ...state,
        adminShareFavouriteFilterStatus: action.payload,
      };

    case 'API_START':
      if (action.payload === 'POST_ADMIN_SHARE_FAVOURITE_FILTER_STATUS') {
        return {
          ...state,
          adminShareFavouriteFilterStatus: null,
          isLoadingAdminShareFavouriteFilterStatus: true,
        };
      }
      return state;

    case 'API_END':
      if (action.payload === 'POST_ADMIN_SHARE_FAVOURITE_FILTER_STATUS') {
        return {
          ...state,
          isLoadingAdminShareFavouriteFilterStatus: false,
        };
      }
      return state;

    case 'RESET_ADMIN_SHARE_FAVOURITE_STATUS':
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
